import httpClienteToken from '../services/httpClientToken';

export const ObtenerDistritoJudicial = (  ) => {

    return new Promise( (resolve, eject) => {

        const data = JSON.parse(window.localStorage.getItem('data'));

        if( data ){
            const { token } = data;

            httpClienteToken.get('/Api/DistritoJudicial/ObtenerDistritoJudicial/',  token)
            .then( response => {
                if( response.status === 200 ){
                    resolve( response );
                }
            })
            .catch( (error) => {
                resolve( error.response );
            });
        }

    });

}